export default __webpack_public_path__ + "static/media/metalCoinSpin.b997c4ea.gif";